import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'tn_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Slight delay so it doesn't flash immediately on load
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 pointer-events-none"
    >
      <div className="pointer-events-auto max-w-3xl mx-auto bg-gray-900 border border-gray-700/80 rounded-2xl shadow-2xl shadow-black/50 p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Icon */}
        <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 bg-teal-500/10 rounded-lg border border-teal-500/20">
          <i className="ri-shield-check-line text-teal-400 text-base"></i>
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-semibold mb-0.5">We use cookies</p>
          <p className="text-gray-400 text-xs leading-relaxed">
            ToolNova uses cookies to improve your experience and analyze site traffic. By clicking Accept, you agree to our{' '}
            <Link
              to="/privacy-policy"
              className="text-teal-400 hover:text-teal-300 underline underline-offset-2 transition-colors cursor-pointer"
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        {/* Buttons */}
        <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
          <button
            onClick={handleDecline}
            className="flex-1 sm:flex-none whitespace-nowrap px-4 py-2 text-xs font-semibold text-gray-400 hover:text-white bg-gray-800 hover:bg-gray-700 border border-gray-700 hover:border-gray-600 rounded-lg transition-all duration-200 cursor-pointer"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 sm:flex-none whitespace-nowrap px-5 py-2 text-xs font-bold text-white bg-teal-500 hover:bg-teal-400 rounded-lg transition-all duration-200 hover:scale-[1.02] cursor-pointer"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
